import React, { useMemo } from 'react';
import { arrayOf, shape, string } from 'prop-types';

const Sources = ({ sources }) =>
    useMemo(() =>
        sources
            .map(({ src, type }) =>
                <source key={src} src={src} type={type}/>
            )
    , [sources]);

Sources.propTypes = {
    sources: arrayOf(
        shape({
            src: string.isRequired,
            type: string
        })
    )
};

export default Sources;
